import React, {Component} from 'react'
import {Link} from 'react-router'
import {extlink, outbound} from '../analytics/outbound'
import Footer from '../footer'

const styles = {
  container: {
    fontSize: `1vw`,
    width: `100%`,
  },
  link: {
    cursor: `pointer`,
    textDecoration: `none`,
    color: `#4C4CFF`,
  },
  content: {
    position: `relative`,
    top: `-0.9em`,
    textAlign: `center`,
    color: `beige`,
    fontSize: `5em`,
    width: `100%`,
    textShadow: `0.05em 0.05em 0.05em black`,
  },
  title1: {
    padding: `1em 1em 1em 1em`,
  },
  title2: {
    padding: `4em 1em 0.7em 1em`,
  },
  uncommon: {
    fontFamily: `proxima-nova,Helvetica Neue,Helvetica,Arial,sans-serif`,
    fontWeight: 300,
  },
}

// TODO: client-side logging for 404 not found messages

export default class NotFound extends Component {
  render() {
    return <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.title1}>Oops, we could not find what you were looking for.</div>
      </div>
      <Footer/>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/error/not_found.js